<template>
  <div class="main">
    <div class="head" @click="showTime =true">
      <div>
        <span>{{checkYear}}</span>
        <img src="../assets/pull.png" alt=""> 
      </div>
      <div style="margin-left: 15px;">
        <span>{{checkMonth}}</span>
        <img src="../assets/pull.png" alt="">
      </div>
    </div>
    <div class="timeList">
      <ul>
        <li>周一</li>
        <li>周二</li>
        <li>周三</li>
        <li>周四</li>
        <li>周五</li>
        <li>周六</li>
        <li>周日</li>
      </ul>
      <div class="date">
        <div  v-for="(item, index) in dayList" :key="index" @click="change(item,index)">
          <div class="day" :class="actived == item.Day ? 'actived' :''">{{item.Day}}</div>
          <div class="consumption" v-if="item.MealFee!=0">{{item.MealFee}}</div>
        </div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="orderList" v-if="orderList.length > 0">
      <ul>
        <li v-for="(item, index) in orderList" :key="index">
          <div class="itemTop">
            <div class="leftTil">{{ item.lastName }}</div>
            <!-- <div class="price">{{item.nprice}}</div> -->
            <div class="price">{{ item.drMealFee }}</div>
          </div>
          <div class="itemBom">
            <div class="itemAdress">{{ item.cCanteenName }}</div>
            <div class="itemDate">{{ item.adddate }}</div>
          </div>
        </li>
      </ul>
    </div>
    <div v-else style="margin: 60px auto 0; text-align: center">暂无数据</div>
    <van-calendar
      v-model="show"
      :min-date="minDate"
      :show-subtitle="false"
      :max-date="maxDate"
      color="rgb(100, 133, 230)"
      @confirm="onConfirm"
    />
    <div class="scanBtn" @click="scanFunc">
      <img src="../assets/scanBtn.png" alt="" />
    </div>
    <div style="height: 60px"></div>
    <van-popup v-model="showFalse" round closeable>
      <div class="falseCont">
        <div class="fTopImg"><img src="../assets/scanFalse.png" alt="" /></div>
        <div class="fTil">扫码失败</div>
        <div class="fText">{{ falseCont }}</div>
      </div>
    </van-popup>
    <van-popup v-model="showTrue" round closeable>
      <div class="trueCont">
        <div class="tTil">确认支付</div>
        <div class="tCenter">
          <span class="price">{{ scanAllText.mealFee }}</span>
          <!-- 2022.8.22 晚六点修改 -->
          <!-- <span class="price" v-if="scanAllText.canteenType=='食堂'">-15</span> -->
          <!-- <span class="price" v-if="scanAllText.canteenType=='廉政灶'">-30</span> -->
          元就餐费
        </div>
        <div class="tUser">
          <span class="tname" v-if="scanAllText && scanAllText.workerName">{{
            scanAllText.workerName
          }}</span
          >在<span class="tdate" v-if="nowDate">{{ nowDate }}</span>
        </div>
        <div class="tBom">
          即将支付<span
            class="taddress"
            v-if="scanAllText && scanAllText.canteenName"
            >{{ scanAllText.canteenName }}</span
          >
        </div>
        <van-cell
          v-if="scanAllText && scanAllText.businessUnitList.length > 1"
          value-class="van-ellipsis"
          title="出差单位："
          is-link
          :value="companyText"
          @click="showCompanuBox"
        />
        <div class="tBomBtnBox">
          <div class="tBtnLeft" @click="showTrue = false">撤回</div>
          <div class="tBtnRight" @click="getScanText2">确定</div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showCompanu" round position="bottom">
      <van-picker
        show-toolbar
        :columns="companycolumns"
        @cancel="showCompanu = false"
        @confirm="onConfirmCompany"
      />
    </van-popup>
    <van-popup v-model="showTime" position="bottom">
        <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="cancel"
        @confirm="confirm"
      />
      </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Calendar, Icon, Toast } from "vant";
import qs from "qs";
import { Dialog } from "vant";
import { Cell, CellGroup } from "vant";

Vue.use(Cell);
Vue.use(Calendar);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Dialog);
import { addBaseAplus } from "../utils/zzdmd.js";
export default {
  name: "order",
  data() {
    return {
      currentDate: new Date(),
      showTime: false,
      actived: 0,
      date: this.formatDate(new Date()),
      date1: this.formatDate1(new Date()),
      minDate: new Date(new Date().getFullYear() - 2, 0, 1),
      maxDate: new Date(),
      show: false,
      orderList: [],
      showFalse: false,
      falseCont: "",
      showTrue: false,
      scanAllText: "",
      nowDate: "",
      scanText: "",
      showCompanu: false,
      companycolumns: [],
      companyId: 0,
      companyText: "请选择",
      timers: false,
      dayList: [],
      week: 0,
      checkMonth: 0,
      checkYear: 0,
      yearList: [],
      param: {
        WorkerID: JSON.parse(sessionStorage.getItem("userData")).workerID,
        Year: '',
        Month:  ''
      }
    };
  },
  created() {
    this.nowDate = this.getnow();
    var date = new Date(); //当前时间
    var zYear = date.getFullYear();//当前年
    var zMonth = date.getMonth();//当前月
    var zDay = date.getDate();   // 获取当前多少号
    var zX = date.getDay();   // 获取当前周几
    this.week = zX;
    this.actived = zDay;
    this.checkYear = zYear
    this.checkMonth = zMonth+1
    for (var i = 2010; i <= zYear; i++) {  //  通过js代码动态生成年份下拉框
      this.yearList.push({it: i})
    }
    this.getAllOrder();
    this.getDate()
  },
  mounted() {
    addBaseAplus(this.$route);
  },
  activated() {
    this.getAllOrder();
    this.nowDate = this.getnow();
  },
  methods: {
    confirm(val) {
      this.checkYear =  val.getFullYear()
      this.checkMonth =  val.getMonth()+1
      console.log(this.checkMonth);
      console.log(this.maxDate.getMonth()+1);
      if(this.checkYear == (this.maxDate.getFullYear())){
          if(this.checkMonth == (this.maxDate.getMonth()+1)) {
            this.actived = this.maxDate.getDate()
          }else{
            this.actived = null
          } 
      }else{
        this.actived = null
      }
      this.getDate()
      this.showTime = false
    },
    cancel() {
      this.showTime = false
    },
    getDate() {
      this.param.Year =  this.checkYear
      this.param.Month =  this.checkMonth
      this.$post("api/Order/GetDiningRecordToMonth", qs.stringify(this.param), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
      }).then((res) =>{
        this.dayList = []
        for(let i = 0; i < res.data.drList[0].Week-1; i++){
          let it = {Day: '',MealFee: 0,key: i}
          this.dayList.push(it)
        }
        this.dayList = this.dayList.concat(res.data.drList)
      })
    
    },
    change(item,index) {
      this.date= item.DateTime
      this.getAllOrder()
      if(item.Day ===''){
        this.actived = null
      }else{
        this.actived = item.Day
      }
    },
    // 获取某年某月的天数
    panduan(year, month) {
        var days = new Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
        if (year % 400 == 0 || (year % 4 == 0 && year % 100 != 0)) {// 闰年
            days[1] = 29;
        }
        return days[month];
    },
    showCompanuBox() {
      this.companycolumns = [];
      if (this.scanAllText && this.scanAllText.businessUnitList.length > 1) {
        this.scanAllText.businessUnitList.map((item, index) => {
          this.companycolumns.push({
            text: item.olName,
            value: item.id,
          });
        });
      }
      this.showCompanu = true;
    },
    onConfirmCompany(e) {
      this.companyId = e.value;
      this.companyText = e.text;
      this.showCompanu = false;
    },
    getAllOrder() {
      console.log(this.date);
      let param = {
        WorkerID: JSON.parse(sessionStorage.getItem("userData")).workerID,
        // WorkerID:10375,
        TheDateTime: this.date,
      };
      this.$post("api/Order/GetDiningRecord", qs.stringify(param), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }).then((res) => {
        if (res.code == 1000) {
          // res.data.map((item)=>{
          //   if(item.cCanteenType=='食堂'){
          //     item.nprice='-15'
          //   }else if(item.cCanteenType=='廉政灶'){
          //     item.nprice='-30'
          //   }else{
          //     item.nprice='0'
          //   }
          // })
          this.orderList = res.data;
        }
      });
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    formatDate1(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    onConfirm(date) {
      this.show = false;
      this.date = this.formatDate(date);
      this.date1 = this.formatDate1(date);
      this.getAllOrder();
    },
    getUrlKey1: function (name, url) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            url
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    scanFunc() {
      let _this = this;
      this.$post("api/Dingding/GetJSAPOTicket")
        .then((res) => {
          if (res.code == 1000) {
            let ticket = res.data.content.data.accessToken;
            //01 获取鉴权码
            // 02  鉴权
            dd.authConfig({
              ticket: ticket,
              jsApiList: ["scan"],
            })
              .then((res) => {
                // 03 判断鉴权结果后，使用获取地理位置
                dd.scan({
                  type: "qr",
                }).then((res) => {
                  this.getScanText(this.getUrlKey1("qrcode", res.text));
                });
              })
              .catch((err) => {
                Dialog.alert({
                  title: "提示",
                  message: "打开扫码失败",
                }).then(() => {
                  // on close
                });
              });
          }
        })
        .catch((err) => {
          Dialog.alert({
            title: "提示",
            message: "打开扫码失败",
          }).then(() => {
            // on close
          });
        });
    },
    getScanText(text) {
      this.scanText = text;
      let param = {
        QRCode: text,
        WorkerID: JSON.parse(sessionStorage.getItem("userData")).workerID,
        // WorkerID:102061,
        Probe: false,
      };
      this.$post("api/Canteen/Estimate", qs.stringify(param), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }).then((res) => {
        if (res.code == 1000) {
          this.scanAllText = res.data;
          if (res.data.businessUnitList.length == 1) {
            this.companyId = res.data.businessUnitList[0].id;
          }
          this.showTrue = true;
        } else {
          this.falseCont = res.msg || res.message;
          this.showFalse = true;
        }
      });
    },
    getScanText2() {
      if (this.timers) {
        setTimeout(() => {
          this.timers = false;
        }, 1000);
        return;
      }
      this.timers = true;
      if (this.scanAllText && this.scanAllText.businessUnitList.length > 1) {
        if (!this.companyId) {
          Toast({
            message: "请先选择出差单位",
            position: "bottom",
          });
          return;
        }
      }
      this.showTrue = false;
      let param = {
        QRCode: this.scanText,
        WorkerID: JSON.parse(sessionStorage.getItem("userData")).workerID,
        // WorkerID:102061,
        Probe: true,
        Longitude: sessionStorage.getItem("userLon"),
        Latitude: sessionStorage.getItem("userLat"),
        BusinessUnit: this.companyId || 0,
      };
      this.$post("api/Canteen/Estimate", qs.stringify(param), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }).then((res) => {
        if (res.code == 1000) {
          this.$router.push({
            path: "/scanSucess",
            query: {
              oid: res.data.orderID,
              cid: res.data.canteenID,
              mealFee: res.data.mealFee,
            },
          });
        } else {
          this.falseCont = res.msg || res.message;
          this.showFalse = true;
        }
      });
    },
    getnow(dates) {
      var mynow = dates ? new Date(dates) : new Date(); //默认的获取的是当前时间
      //通过调用日期对象的方法来重新获取当前的日期时间
      //mynow.setFullYear(2016);
      var year = mynow.getFullYear(); //获取年
      var month =
        mynow.getMonth() + 1 < 10
          ? "0" + (mynow.getMonth() + 1)
          : mynow.getMonth() + 1; //获取月
      var day = mynow.getDate() < 10 ? "0" + mynow.getDate() : mynow.getDate(); //获取日
      var hour =
        mynow.getHours() < 10 ? "0" + mynow.getHours() : mynow.getHours(); //获取小时
      var minute =
        mynow.getMinutes() < 10 ? "0" + mynow.getMinutes() : mynow.getMinutes(); //获取分钟
      // var second =mynow.getSeconds();//获取秒
      var strdate = year + "-" + month + "-" + day + " " + hour + ":" + minute;
      return strdate;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  background: #f2f2f2;
  min-height: 100vh;
  overflow: hidden;
}
.head {
  width: 351px;
  margin: 0 auto;
  display: flex;
  margin: 7px 0;

}
.head >div {
  margin-left: 15px;
}
.head img {
  width: 15px;
}
.select {
  outline: none;
}
#year {
  border: 0;
  background: transparent;
}
#month {
  border: 0;
  background: transparent;
}

.selectCalen {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
}

.selectCalenCont {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  width: fit-content;
}

.scanBtn {
  width: 58px;
  height: 58px;
  position: fixed;
  bottom: 72px;
  right: 8px;
  z-index: 1;
}

.scanBtn > img {
  width: 100%;
  height: 100%;
}

.timeList {
  width: 351px;
  height: 347.5px;
  background: #fff;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 15px;
  overflow: hidden;
  border-radius: 5px;
}
.timeList > ul {
  display: flex;
  margin-top: 40px;
}
.timeList ul > li {
  width: 45px;
  text-align: center;
  font-weight: 700;
}
.date {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
}
.date > div {
  position: relative;

}
.day {
  width: 45px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}
.consumption {
  width: 32px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  display: inline-block;
  background: #DAEBFD;
  border-radius: 8px;
  font-size: 10px;
  color: #469CF7;
  position: absolute;
  top: 32px;
  left: 7.5px;
}
.actived {
  background: #469CF7;
  border-radius: 50%;
  color: #fff;
}
.orderList {
  box-sizing: border-box;
  width: 351px;
  background: #fff;
  margin:  0 auto;
  margin-top: 10px;
}

.orderList > ul > li {
  box-sizing: border-box;
  height: 76.5px;
  padding: 10px 10px;
  border-bottom: 1px solid #e6e6e6;
}

.orderList > ul > li:last-child {
  border: none;
}

.itemTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.leftTil {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.itemDate {
  font-size: 12px;
  font-weight: 500;
  color: #999999;
  max-width: 116px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.itemBom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.itemAdress {
  font-size: 12px;
  font-weight: 500;
  color: #666666;
  max-width: calc(100% - 120px);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.price {
  font-size: 16px;
  color: #ea6363;
}

.falseCont {
  box-sizing: border-box;
  padding: 50px 42px;
  background-color: #fff;
  border-radius: 5px;
  width: 80vw;
  text-align: center;
}

.fTopImg {
  width: 44px;
  height: 44px;
  margin: 0 auto;
}

.fTopImg > img {
  width: 100%;
  height: 100%;
}

.fTil {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  margin-top: 15px;
}

.fText {
  font-size: 12px;
  font-weight: 500;
  color: #666666;
  margin-top: 10px;
}

.trueCont {
  box-sizing: border-box;
  padding: 12px 28px;
  background-color: #fff;
  border-radius: 5px;
  width: 80vw;
  text-align: center;
}

.tTil {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}

.tCenter {
  margin-top: 24px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}

.price {
  font-size: 28px !important;
  color: #ea6363 !important;
}

.tUser {
  margin-top: 12px;
  font-size: 14px;
  color: #333333;
}

.tdate {
  color: #3b87f5 !important;
}

.tBom {
  margin-top: 4px;
  font-size: 14px;
  color: #333333;
}

.tBomBtnBox {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 15px;
}

.tBtnLeft {
  padding: 5px 22px;
  border-radius: 4px;
  border: 1px solid #3b87f5;
  font-size: 16px;
  color: #3b87f5;
}

.tBtnRight {
  padding: 5px 22px;
  border-radius: 4px;
  font-size: 16px;
  color: #fff;
  background: #3b87f5;
}
</style>



// WEBPACK FOOTER //
// src/page/order.vue